import image from "../../assets/about-image.jpg";

export const CONTACT = [
  {
    img: image,
  },
];
